/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_dice_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Each face is equally likely on every roll.`)
};

const es_dice_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada cara tiene la misma probabilidad en cada tirada.`)
};

const de_dice_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jede Seite ist bei jedem Wurf gleich wahrscheinlich.`)
};

const nl_dice_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elk vlak heeft bij elke worp evenveel kans.`)
};

const fr_dice_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chaque face a une probabilité égale à chaque lancer.`)
};

const it_dice_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ogni faccia ha la stessa probabilità a ogni lancio.`)
};

const pt_br2_dice_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada face tem a mesma probabilidade em cada rolagem.`)
};

const pt_dice_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada face tem a mesma probabilidade em todos os lançamentos.`)
};

const ja_dice_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`どの目も毎回等しい確率で出ます。`)
};

const zh_dice_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每次投掷中，每一面出现的概率都相同。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const dice_ex3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.dice_ex3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("dice_ex3", locale)
	if (locale === "en") return en_dice_ex3(inputs)
	if (locale === "es") return es_dice_ex3(inputs)
	if (locale === "de") return de_dice_ex3(inputs)
	if (locale === "nl") return nl_dice_ex3(inputs)
	if (locale === "fr") return fr_dice_ex3(inputs)
	if (locale === "it") return it_dice_ex3(inputs)
	if (locale === "pt-BR") return pt_br2_dice_ex3(inputs)
	if (locale === "pt") return pt_dice_ex3(inputs)
	if (locale === "ja") return ja_dice_ex3(inputs)
	return zh_dice_ex3(inputs)
};